import {useState} from 'react';
import {Button, Modal} from 'react-bootstrap';

import MonitorForm from "./monitor-form.jsx";

const MonitorModal = () => {
  const [showModal, setShowModal] = useState(false);
  
  const handleShowModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);
  
  const clientNotificate = async () => {
    if (!("Notification" in window) || !("serviceWorker" in navigator)) {
      alert("Navegador não suporta notificações ou service worker");
      return;
    }
    
    const permission = await Notification.requestPermission();
    if (permission !== "granted") {
      alert("Permissão de notificação negada");
      return;
    }
    
    const registration = await navigator.serviceWorker.ready;
    
    registration.showNotification("Aviso do app", {
      body: "Essa notificação foi enviada via Service Worker direto.",
      icon: "/images/icon-white-192x192.png",
      badge: "/images/icon-white-192x192.png",
      tag: "notificacao-teste",
      renotify: true,
    }).then();
  };
  
  return (
    <>
      <div className={"d-none"}>
        <Button
          variant={"info"}
          size={"sm"}
          onClick={() => (async () => {
            handleShowModal()
            await clientNotificate()
          })()}
        >
          <span>Acompanhar</span>
          <i className="bi bi-bell"></i>
        </Button>
      </div>
      
      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton className={"border-0"}>
          <Modal.Title className={"fw-semibold"} style={{fontSize: "1.35rem"}}>Receber informações da linha</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <MonitorForm handleCloseModal={handleCloseModal}/>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default MonitorModal;
